import DmsSyncType from '@/shared/constants/DmsSyncType';
import { parseEntity } from '@/shared/converters/commonConverters';
import DmsSyncStatus from '@/shared/models/DmsSyncStatus';
import DmsObjectStatus from '../models/DmsObjectStatus';

const SYNC_SCHEMA = {
  finishedImporting: 'finishedImporting',
  pusherChannel: 'pusherChannel',
  pusherChannelEventName: 'pusherChannelEventName',
};

const OBJECT_SCHEMA = {
  dmsSyncType: 'dmsSyncType',
  payload: (data: any) => {
    if (data?.dmsSyncType === DmsSyncType.LAZY) {
      return parseDmsSyncStatus(data.payload);
    }
    return data.payload;
  },
};

export function parseDmsSyncStatus(data: any): DmsSyncStatus | null {
  return parseEntity(data, SYNC_SCHEMA, DmsSyncStatus);
}

export function parseDmsObjectStatus(data: any): DmsObjectStatus | null {
  return parseEntity(data, OBJECT_SCHEMA, DmsObjectStatus);
}
